// -didim_realty_world
import clsx from "clsx";
import { useEffect, useState } from "react";

interface LoaderProps {
    isLoading: boolean
}

const Loader: React.FC<LoaderProps> = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [showTime] = useState(Date.now());

    useEffect(() => {
        if (!props.isLoading) {
            // Minimum 600ms göster
            const elapsed = Date.now() - showTime;
            const minDisplayTime = 1600;
            const remainingTime = Math.max(0, minDisplayTime - elapsed);

            setTimeout(() => {
                setIsLoaded(true);
            }, remainingTime);
        } else {
            setIsLoaded(false);
        }
    }, [props.isLoading, showTime]);

    return (
        <div className={clsx(
            "fixed inset-0 z-[9999] flex items-center justify-center bg-background-light dark:bg-background-dark transition-opacity duration-500",
            {
                "opacity-0 pointer-events-none": isLoaded,
                "opacity-100": !isLoaded
            }
        )}>
            <div className="flex flex-col items-center gap-6">
                {/* House Icon with Animation */}
                <div className="relative">
                    {/* Animated Ping Ring */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-24 h-24 border-4 border-primary/20 rounded-full animate-ping"></div>
                    </div>

                    {/* Rotating Ring */}
                    <div className="absolute inset-0 flex items-center justify-center">
                        <div className="w-24 h-24 border-4 border-transparent border-t-primary rounded-full animate-spin"></div>
                    </div>

                    {/* House Icon */}
                    <div className="relative flex items-center justify-center w-24 h-24">
                        <span className="material-symbols-outlined text-primary text-[48px] animate-pulse">
                            home
                        </span>
                    </div>
                </div>

                {/* Loading Text */}
                <div className="flex flex-col items-center gap-2">
                    <h3 className="text-xl font-bold text-secondary dark:text-white">
                        Yükleniyor...
                    </h3>
                    <div className="flex gap-1">
                        <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                        <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                        <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default Loader;
